import { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import moment from "moment";
import { useCookies } from "react-cookie";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Pagination from "../../Components/Pagination";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
function UploadISEE(props) {
  const apiToken = useContext(TokenContext);
  const [cookies] = useCookies();
  const [value, setValue] = useState();
  const [uploadISEE, setUploadISEE] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationISEE, setValidationISEE] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [isAlertVisible, setIsAlertVisible] = useState();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);

  const [userIsees, setUserIsees] = useState();
  const [userIseesTemp, setUserIseesTemp] = useState();
  const [user, setUser] = useState({});
  const ref = useRef();
  let query = useQuery();
  const [isOpeniSEE, toggleModalisee] = useState(false);
  const [removableISEE, setRemovableISEE] = useState({});

  useEffect(() => {
    if (data != null) {
      const timer = setTimeout(() => {
        setLoading(true);
        setIsAlertVisible(false);

        window.location.href = props.subfolder + "/home";
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isAlertVisible, data]);

  useEffect(() => {
    if (query.get("scroll")) {
      window.scrollTo(0, ref.current.offsetHeight + 150);
    }

    Repo.getUser(apiToken)
      .then((response) => {
        setUser(response.data);
        setUserIseesTemp(response.data.isees);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const sendISEE = async () => {
    setValidation(true);
    setValidationISEE(true);

    let passedValidation = true;

    let tempData = {};
    const d = moment();

    if (uploadISEE) {
      var splitBase64 = uploadISEE.split(",");

      const mimeType = splitBase64[0]; // Il tipo MIME completo
      const parts = mimeType.split(";"); // Suddivide la stringa in base al carattere ';'
      const imageType = parts[0].split(":")[1]; // Rimuovi "data:" dalla parte centrale

      tempData["base64"] = splitBase64[1];
      tempData["type"] = imageType;
    } else {
      passedValidation = false;
      setValidationISEE(false);
    }

    var localFormat = "YYYY-MM-DD[T]HH:mm:ss";

    tempData["year"] = d.year();
    tempData["date"] = d.format(localFormat);

    if (value == "" || value == " " || !value) passedValidation = false;

    tempData["value"] = value?.replace(".", "").replace(",", ".");

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const sendISEEApi = async () => {
    setLoading(false);
    Repo.postSendIsee(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          setIsAlertVisible(true);

          toggleModal(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const removeIseeAPI = async () => {};

  return (
    <>
      <h1>Caricamento ISEE</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Carica un nuovo ISEE. Il nuovo ISEE caricato andrà ad invalidare il
          valore dell'ISEE precedente
        </p>
      </div>

      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-8">
                <UploadFile
                  setErrorMessage={setErrorMessage}
                  typeFile={[
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ]}
                  handleFile={setUploadISEE}
                ></UploadFile>

                {errorMessage && (
                  <div className="text-danger">
                    Carica un file con un formato supportato
                  </div>
                )}
                {validation && !validationISEE ? (
                  <div className="text-danger">
                    Non è stato caricato nessun documento
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-lg-4 pl-5">
                <h6 className="mb-5">Valore ISEE*</h6>
                <div className="row mb-4">
                  <Input
                    id="value"
                    value={value}
                    name="Valore ISEE"
                    onChange={(e) =>
                      setValue(
                        e.target.value.match(number) ? e.target.value : value
                      )
                    }
                    {...(validation &&
                      (value == "" || value == " " || !value) && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>
                <div className="row my-2">
                  <div className="col-lg-12 text-right">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => sendISEE()}
                      title="Conferma"
                    >
                      Conferma
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom">
          <div className="card-body" key="isee" ref={ref}>
            <div className="categoryicon-top">
              <svg className="icon">
                <use href={`${iconSprite}#it-copy`}></use>
              </svg>
              <span className="text">
                ({userIsees ? userIsees.length : 0}) ISEE Caricati
              </span>
            </div>

            {userIseesTemp && userIsees && userIsees.length > 0 ? (
              userIsees.map((x) => (
                <div key={x.id}>
                  <div className="row mt-4">
                    <div className="col-lg-3 text-left">
                      <strong>
                        {x.value &&
                          parseFloat(x.value).toLocaleString("it-IT", {
                            minimumFractionDigits: 2,
                          })}
                        &nbsp;€
                      </strong>
                    </div>
                    <div className="col-lg-3 text-left">
                      Data inserimento: <strong>{x.date}</strong>
                    </div>
                    <div className="col-lg-3 text-center">
                      Anno: <strong>{x.year}</strong>
                    </div>
                    <div className="col-lg-2 text-left">
                      {x.state == "VALIDATED" ? (
                        <div>
                          <b className="text-success">
                            <svg className="icon icon-success">
                              <use href={`${iconSprite}#it-check-circle`} />
                            </svg>{" "}
                            ACCETTATO
                          </b>
                        </div>
                      ) : x.state == "LOADED" ? (
                        <b className="">
                          <svg className="icon">
                            <use href={`${iconSprite}#it-close-circle`} />
                          </svg>
                          DA VERIFICARE
                        </b>
                      ) : x.state == "REFUSED" ? (
                        <b className="text-danger">
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-close-circle`} />
                          </svg>{" "}
                          RIFIUTATO
                        </b>
                      ) : (
                        <b className="text-danger">
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-close-circle`} />
                          </svg>{" "}
                          {y.state}
                        </b>
                      )}
                    </div>
                    <div className="col-lg-1 text-center">
                      {x.state == "LOADED" ? (
                        <button
                          className="btn btn-outline-danger p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="È possibile eliminare l'ISEE solo quando è in stato di verifica "
                          onClick={() => {
                            toggleModalisee(!isOpeniSEE);
                            setRemovableISEE({
                              id: x.id,
                              valore: parseFloat(x.value).toLocaleString(
                                "it-IT"
                              ),
                              year: x.year,
                              date: x.date,
                            });
                          }}
                        >
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      ) : (
                        <button
                          className="btn btn-outline-secondary disabled p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Non è possibile cancellare l'ISEE!"
                        >
                          <svg className="icon icon-secondary">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                  <hr></hr>
                </div>
              ))
            ) : (
              <>Non sono presenti ISEE</>
            )}
            {userIseesTemp && (
              <div className="mt-3">
                <Pagination
                  items={userIseesTemp}
                  setCurrentItems={setUserIsees}
                  itemsPerPage={5}
                ></Pagination>
              </div>
            )}
          </div>
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalisee}
        isOpen={isOpeniSEE}
        header={
          "Rimozione ISEE: " +
          removableISEE.valore +
          " " +
          " dell' anno " +
          removableISEE.year
        }
        body={
          "Confermi di voler rimuovere ISEE " +
          removableISEE.valore +
          " " +
          " dell' anno " +
          removableISEE.year +
          " caricato il " +
          removableISEE.date +
          "?"
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeIseeAPI()}
      ></ModalComponent>
      {isAlertVisible && (
        <>
          <div
            className="alert alert-success"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>
              Il caricamento è avvenuto con successo! Verrai reindirizzato
              all'Home Page.
            </b>
          </div>
        </>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
}

export default UploadISEE;
